/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2026 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import React, { useCallback, useState } from 'react'
import InputText from '@/components/forms/InputText'
import Buttons from '@/components/listings/DefaultFilterInput/components/Buttons'
import { Flex, FormControl, FormErrorMessage } from '@chakra-ui/react'
import { DEFAULT_APPLY_FILTER_LABEL } from '@/configs/strings/filters.strings'
import { applyFilterParams } from '@/utils/url'

const FilterByName = ({
  labelFilter = DEFAULT_APPLY_FILTER_LABEL,
  onFilterResults,
  resetFilter,
  value
}) => {
  const VALUE_REQUIRED_ERROR = 'You must write a value'
  const [hasError, setHasError] = useState(false)
  const validateFilter = useCallback((value) => {
    const normalizedValue = typeof value === 'string' ? value.trim() : value
    if (normalizedValue === '' || normalizedValue == null) {
      return { isValid: false, message: VALUE_REQUIRED_ERROR }
    }

    return { isValid: true, message: null }
  }, [])
  const [currentFilterState, setCurrentFilterState] = useState(value)
  const updateFilterValue = useCallback((e) => {
    setHasError(false)
    setCurrentFilterState(e.target.value)
  }, [])
  const flexGap = { base: '3', md: '3' }
  const flexDirection = {
    base: 'column',
    md: 'row'
  }

  const onFilter = () => {
    const validation = validateFilter(currentFilterState)
    if (!validation.isValid) {
      setHasError(true)
      return false
    }
    applyFilterParams({
      name: currentFilterState
    }, onFilterResults)
  }

  const currentOnReset = () => {
    setHasError(false)
    setCurrentFilterState('')
    resetFilter?.()
  }

  return (
    <Flex
      justifyContent="space-between"
      flexDirection={flexDirection}
      gap={flexGap}
    >
      <FormControl isInvalid={hasError}>
        <InputText
          value={currentFilterState}
          onChange={updateFilterValue}
          placeholder="Filter by Name"
        />
          <FormErrorMessage>{ VALUE_REQUIRED_ERROR }</FormErrorMessage>
      </FormControl>
      <Buttons
        applyFilter={onFilter}
        labelFilter={labelFilter}
        onReset={true}
        resetFilter={currentOnReset}
      />
    </Flex>
  )
}

export default FilterByName
